import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, resolveComponent as _resolveComponent, mergeProps as _mergeProps, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3b5c2356"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "lf-table" }
const _hoisted_2 = { class: "header" }
const _hoisted_3 = { class: "title" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_5 = { key: 1 }
const _hoisted_6 = { class: "handler" }
const _hoisted_7 = {
  key: 0,
  style: {"color":"#ff0000"}
}
const _hoisted_8 = { key: 1 }
const _hoisted_9 = { class: "footer" }

import { withDefaults, watch, ref } from 'vue'
import { ElLoading, ElMessage, ElMessageBox,ElTooltip  } from 'element-plus'

export default /*#__PURE__*/_defineComponent({
  __name: 'LfTable',
  props: {
    title: { default: '' },
    tips: {},
    tooltip: {},
    listData: {},
    listCount: { default: 0 },
    propList: { default: [] },
    rules: { default: [] },
    showIndexColumn: { type: Boolean, default: false },
    showSelectColumn: { type: Boolean, default: false },
    page: { default: { pageNo: 1, pageSize: 10 } },
    childrenProps: { default: {} },
    showFooter: { type: Boolean, default: true }
  },
  emits: ["selectionChange", "sortChange", "rowClick", "update:page", "mouseEnter", "mouseLeave"],
  setup(__props: any, { emit: __emit }) {

const props = __props

const emit = __emit

const handleSlectionChange = (value: any[]) => {
  emit('selectionChange', value)
}

const handleSortChange = (value: any) => {
  emit('sortChange', value)
}

const handleRowClick = (row: any, cloumn: any) => {
  emit('rowClick', row, cloumn)
}

const handleSizeChange = (pageSize: number) => {
  emit('update:page', { ...props.page, pageSize })
}
const handleCurrentChange = (pageNo: number) => {
  emit('update:page', { ...props.page, pageNo })
}

const handleMouseEnter = (
  row: any,
  column: any,
  cell: HTMLElement,
  event: MouseEvent
) => {
  emit('mouseEnter', row, column, cell, event)
}

const handleMouseLeave = (
  row: any,
  column: any,
  cell: HTMLElement,
  event: MouseEvent
) => {
  emit('mouseLeave', row, column, cell, event)
}


const isInRules = (prop: string, row: any) => {
  let checked = true
  props.rules.forEach(function (rule: any) {
    if (typeof rule == 'object') {
      rule = [rule]
    }
    if (rule.some((item: any) => item.key == prop)) {
      for (let i = 0; i < rule.length; i++) {
        let condition = rule[i]
        if (row.deptName.indexOf('518') >= 0) {
          if (condition.type != '518') {
            continue
          }
        } else {
          if (condition.type == 'toujiao') {
            continue
          }
        }
        if (condition.method == '==') {
          checked = checked && row[condition.key] == condition.value
        } else {
          // if (condition.method == '>=') {
          checked = checked && row[condition.key] >= condition.value
        }
      }
    }
  })
  return !checked
}

return (_ctx: any,_cache: any) => {
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _renderSlot(_ctx.$slots, "header", {}, () => [
        _createElementVNode("div", _hoisted_3, [
          (_ctx.tooltip && _ctx.tooltip.length > 0)
            ? (_openBlock(), _createBlock(_unref(ElTooltip), {
                key: 0,
                placement: "top"
              }, {
                content: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tooltip, (item, index) => {
                    return (_openBlock(), _createElementBlock("div", { key: index }, [
                      _createTextVNode(_toDisplayString(item) + " ", 1),
                      _hoisted_4
                    ]))
                  }), 128))
                ]),
                default: _withCtx(() => [
                  _createElementVNode("span", null, _toDisplayString(_ctx.title), 1)
                ]),
                _: 1
              }))
            : (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(_ctx.title), 1)),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tips, (item, index) => {
            return (_openBlock(), _createElementBlock("span", {
              style: _normalizeStyle(item.style),
              key: index
            }, _toDisplayString(item.text), 5))
          }), 128))
        ]),
        _createElementVNode("div", _hoisted_6, [
          _renderSlot(_ctx.$slots, "headerHandler")
        ])
      ])
    ]),
    _createVNode(_component_el_table, _mergeProps({
      border: "",
      stripe: "",
      fit: "",
      data: _ctx.listData,
      style: {"width":"100%"},
      onSelectionChange: handleSlectionChange,
      onSortChange: handleSortChange,
      onRowClick: handleRowClick,
      onCellMouseEnter: handleMouseEnter,
      onCellMouseLeave: handleMouseLeave
    }, _ctx.childrenProps), {
      default: _withCtx(() => [
        (_ctx.showSelectColumn)
          ? (_openBlock(), _createBlock(_component_el_table_column, {
              key: 0,
              type: "selection",
              align: "center",
              width: "60"
            }))
          : _createCommentVNode("", true),
        (_ctx.showIndexColumn)
          ? (_openBlock(), _createBlock(_component_el_table_column, {
              key: 1,
              type: "index",
              align: "center",
              label: "序号",
              width: "80"
            }))
          : _createCommentVNode("", true),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.propList, (propItem) => {
          return (_openBlock(), _createBlock(_component_el_table_column, _mergeProps({
            key: propItem.childProp?propItem.childProp:propItem.prop,
            fixed: propItem.isFixed ? propItem.isFixed : false,
            sortable: propItem.sortable ? propItem.sortable : false,
            ref_for: true
          }, propItem, {
            align: propItem.align ? propItem.align : 'center',
            "show-overflow-tooltip": ""
          }), {
            default: _withCtx((scope) => [
              _renderSlot(_ctx.$slots, propItem.slotName, {
                row: scope.row
              }, () => [
                (isInRules(propItem.prop, scope.row))
                  ? (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(propItem.childProp? scope.row[propItem.prop][propItem.childProp] :scope.row[propItem.prop]), 1))
                  : (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(propItem.childProp? scope.row[propItem.prop][propItem.childProp] :scope.row[propItem.prop]), 1))
              ])
            ]),
            _: 2
          }, 1040, ["fixed", "sortable", "align"]))
        }), 128))
      ]),
      _: 3
    }, 16, ["data"]),
    _createElementVNode("div", _hoisted_9, [
      (_ctx.showFooter)
        ? _renderSlot(_ctx.$slots, "footer", { key: 0 }, () => [
            _createVNode(_component_el_pagination, {
              "current-page": _ctx.page.pageNo,
              "page-sizes": [10, 20, 30, 40, 100],
              "page-size": _ctx.page.pageSize,
              layout: "total, sizes, prev, pager, next, jumper",
              total: _ctx.listCount,
              onSizeChange: handleSizeChange,
              onCurrentChange: handleCurrentChange
            }, null, 8, ["current-page", "page-size", "total"])
          ])
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})